import { Controller } from "@hotwired/stimulus"

// 動的にフォームフィールドを追加・削除するコントローラー
export default class extends Controller {
  static targets = ["container", "template"]
  static values = { index: Number }

  connect() {
    // 初期インデックスを設定（既存のレコード数）
    if (!this.hasIndexValue) {
      this.indexValue = this.containerTarget.querySelectorAll('.nested-fields').length
    }
  }

  add(event) {
    event.preventDefault()

    // テンプレートをクローン
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, this.indexValue)
    this.containerTarget.insertAdjacentHTML('beforeend', content)

    this.indexValue++
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest('.nested-fields')
    const destroyInput = wrapper.querySelector('input[name*="_destroy"]')

    if (destroyInput) {
      // 既存レコードの場合は_destroyフラグを立てて非表示
      destroyInput.value = '1'
      wrapper.style.display = 'none'
    } else {
      // 新規追加の場合はDOMから削除
      wrapper.remove()
    }
  }
}
